import baseAPI from '@/api/base';
import { EditEmployeeSalary, GetEmployeeSalary, RegisterEmployeeSalary } from '@/dtos/employee_salary.dto';
import {
  DELETE_EMPLOYEE_SALARY_URL,
  EDIT_EMPLOYEE_SALARY_URL,
  GET_EMPLOYEE_SALARY_URL,
  REGISTER_EMPLOYEE_SALARY_URL,
  TOGGLE_EMPLOYEE_SALARY_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeSalary {
  static getEmployeeSalaries = async (getEmployeeSalaries: GetEmployeeSalary): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_SALARY_URL, {
      params: getEmployeeSalaries,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeSalary = async (
    registerEmployeeSalary: RegisterEmployeeSalary
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_SALARY_URL, {
      ...registerEmployeeSalary,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeSalary = async (editEmployeeSalary: EditEmployeeSalary): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_SALARY_URL, {
      ...editEmployeeSalary,
    });
    return response;
  };

  static toggleEmployeeSalaryIsActive = async (
    editEmployeeSalary: EditEmployeeSalary
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_SALARY_IS_ACTIVE_URL,
      {
        ...editEmployeeSalary,
      }
    );
    return response;
  };

  static deleteEmployeeSalary = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_SALARY_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeSalary;
